import { render, staticRenderFns } from "./addShopHouse.vue?vue&type=template&id=06f6ba67"
import script from "./addShopHouse.vue?vue&type=script&lang=js"
export * from "./addShopHouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports